import React from 'react';
import { createPortal } from 'react-dom';
import Snackbar from 'components/DesignSystem/Snackbar';
import './index.scss';

// Fixo no canto da tela, fora da linha: o botão de download costuma morar numa coluna estreita
// (Meus Arquivos, tabelas do Admin) onde um aviso inline quebraria o layout.
export default function DownloadErrorSnackbar({
  message,
  onClose,
}: {
  message: string | null,
  onClose: () => void,
}) {
  if (!message) return null;

  return createPortal(
    <Snackbar
      className="download-error-snackbar"
      variant="danger"
      closeButton
      onClose={onClose}
    >
      <span role="alert">{message}</span>
    </Snackbar>,
    document.body,
  );
}
